"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlledFilter = exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactMeasure = _interopRequireDefault(require("react-measure"));

var _formik = require("formik");

var _recompose = require("recompose");

var _reactPopper = require("react-popper");

var _styles = require("./styles");

var _View = _interopRequireDefault(require("../View"));

var _Row = _interopRequireDefault(require("../Row"));

var _FilterButton = _interopRequireDefault(require("./FilterButton"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var popperModifiers = {
  offset: {
    fn: function fn(data) {
      if (data.placement.indexOf('top') !== -1) {
        data.offsets.popper.top -= 10;
      }

      return data;
    }
  }
};

var Filter =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Filter, _PureComponent);

  function Filter() {
    (0, _classCallCheck2["default"])(this, Filter);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Filter).apply(this, arguments));
  }

  (0, _createClass2["default"])(Filter, [{
    key: "renderPanel",
    value: function renderPanel() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var onResize = _ref.onResize,
          passProps = (0, _objectWithoutProperties2["default"])(_ref, ["onResize"]);
      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          onClear = _this$props.onClear,
          onSubmit = _this$props.onSubmit,
          panelProps = _this$props.panelProps,
          hideFooter = _this$props.hideFooter,
          isMobile = _this$props.isMobile;
      if (!this.hasPanel) return;
      return _react["default"].createElement(_styles.Panel, (0, _extends2["default"])({
        pose: isMobile ? 'mobile' : 'desktop'
      }, panelProps, passProps), title && _react["default"].createElement(_styles.Title, null, title), _react["default"].createElement(_reactMeasure["default"], {
        bounds: true,
        onResize: onResize
      }, function (_ref2) {
        var measureRef = _ref2.measureRef;
        return _react["default"].createElement(_Row["default"], {
          ref: measureRef,
          className: "panelBody"
        }, children);
      }), !hideFooter && _react["default"].createElement(_Row["default"], {
        className: "panelFooter"
      }, onClear && _react["default"].createElement(_styles.PanelButton, {
        isMobile: isMobile,
        onClick: onClear
      }, "Limpar"), onSubmit && _react["default"].createElement(_styles.PanelButton, {
        active: true,
        isMobile: isMobile,
        onClick: onSubmit
      }, "Aplicar")));
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      var passProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props2 = this.props,
          label = _this$props2.label,
          formatLabel = _this$props2.formatLabel,
          selectedValue = _this$props2.selectedValue,
          selected = _this$props2.selected,
          onSelect = _this$props2.onSelect,
          hasValue = _this$props2.hasValue,
          value = _this$props2.value,
          props = (0, _objectWithoutProperties2["default"])(_this$props2, ["label", "formatLabel", "selectedValue", "selected", "onSelect", "hasValue", "value"]);
      delete props.onClear;
      delete props.onSubmit;
      return _react["default"].createElement(_View["default"], (0, _extends2["default"])({
        style: {
          position: 'static'
        }
      }, passProps), _react["default"].createElement(_FilterButton["default"], (0, _extends2["default"])({}, props, {
        className: "filterButton",
        selected: selected || hasValue,
        disabled: selectedValue && !selected,
        onClick: onSelect
      }), formatLabel ? formatLabel(value, hasValue) : label));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props3 = this.props,
          selected = _this$props3.selected,
          isFilterExpanded = _this$props3.isFilterExpanded,
          contentRef = _this$props3.contentRef;
      if (!selected || !this.hasPanel || !contentRef.current) return this.renderButton();else if (isFilterExpanded) {
        return _react["default"].createElement(_react["default"].Fragment, null, this.renderButton(), _reactDom["default"].createPortal(this.renderPanel(), contentRef.current));
      } else {
        return _react["default"].createElement(_reactPopper.Manager, null, _react["default"].createElement(_reactPopper.Reference, null, function (_ref3) {
          var ref = _ref3.ref;
          return _this.renderButton({
            ref: ref
          });
        }), _reactDom["default"].createPortal(_react["default"].createElement(_reactPopper.Popper, {
          positionFixed: true,
          placement: "bottom-start",
          modifiers: popperModifiers
        }, function (_ref4) {
          var ref = _ref4.ref,
              style = _ref4.style,
              scheduleUpdate = _ref4.scheduleUpdate;
          return _this.renderPanel({
            ref: ref,
            style: style,
            onResize: function onResize() {
              return scheduleUpdate();
            }
          });
        }), contentRef.current));
      }
    }
  }, {
    key: "hasPanel",
    get: function get() {
      return Boolean(this.props.children);
    }
  }]);
  return Filter;
}(_react.PureComponent);

exports["default"] = Filter;
(0, _defineProperty2["default"])(Filter, "defaultProps", {
  panelProps: {}
});

var ControlledFilterContainer =
/*#__PURE__*/
function (_PureComponent2) {
  (0, _inherits2["default"])(ControlledFilterContainer, _PureComponent2);

  function ControlledFilterContainer(props) {
    var _this2;

    (0, _classCallCheck2["default"])(this, ControlledFilterContainer);
    _this2 = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ControlledFilterContainer).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "state", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "onChange", function (value) {
      return _this2.setState({
        value: value
      });
    });
    _this2.state.value = _this2.props.value;
    return _this2;
  }

  (0, _createClass2["default"])(ControlledFilterContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var focusChanged = prevProps.selected !== this.props.selected;
      var focusedFilter = this.props.selectedValue;

      if (focusChanged) {
        if (focusedFilter && focusedFilter !== this.props.name && this.state.value !== this.props.value) this.props.setFieldValue(this.props.name, this.state.value);else if (!focusedFilter) this.setState({
          value: this.props.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props4 = this.props,
          children = _this$props4.children,
          name = _this$props4.name,
          selected = _this$props4.selected,
          _onSelect = _this$props4.onSelect,
          initialValues = _this$props4.initialValues,
          isEmpty = _this$props4.isEmpty,
          props = (0, _objectWithoutProperties2["default"])(_this$props4, ["children", "name", "selected", "onSelect", "initialValues", "isEmpty"]);
      var value = this.state.value;
      return _react["default"].createElement(_formik.Field, {
        name: name,
        render: function render(_ref5) {
          var field = _ref5.field,
              form = _ref5.form;
          var initialValue = (0, _get["default"])(initialValues, name);
          var appliedValue = (0, _get["default"])(form.initialValues || {}, name);
          var fieldValue = field.value;
          var hasValue = Boolean(!isEmpty(fieldValue) && !(0, _isEqual["default"])(fieldValue, initialValues[name]));
          return _react["default"].createElement(Filter, (0, _extends2["default"])({}, props, {
            selected: selected,
            value: hasValue ? fieldValue : undefined,
            hasValue: hasValue,
            onSelect: function onSelect() {
              if (selected) {
                form.setFieldValue(name, value);
                requestAnimationFrame(function () {
                  _onSelect();

                  form.submitForm();
                });
              } else {
                _onSelect();
              }
            },
            onClear: function onClear() {
              _this3.setState({
                value: undefined
              });

              form.setFieldValue(name, undefined);
              requestAnimationFrame(function () {
                _onSelect();

                form.submitForm();
              });
            },
            onSubmit: function onSubmit() {
              form.setFieldValue(name, value);
              requestAnimationFrame(function () {
                _onSelect();

                form.submitForm();
              });
            }
          }), children({
            field: _objectSpread({}, field, {
              currentValue: value,
              appliedValue: appliedValue,
              initialValue: initialValue,
              onChange: _this3.onChange
            }),
            form: form
          }));
        }
      });
    }
  }]);
  return ControlledFilterContainer;
}(_react.PureComponent);

(0, _defineProperty2["default"])(ControlledFilterContainer, "defaultProps", {
  isEmpty: function isEmpty(value) {
    return typeof value === 'undefined';
  }
});
var ControlledFilter = (0, _recompose.compose)(_formik.connect, (0, _recompose.mapProps)(function (_ref6) {
  var formik = _ref6.formik,
      props = (0, _objectWithoutProperties2["default"])(_ref6, ["formik"]);
  return _objectSpread({
    value: formik.values[props.name],
    setFieldValue: formik.setFieldValue
  }, props);
}))(ControlledFilterContainer);
exports.ControlledFilter = ControlledFilter;